//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import storeMutations from '~/store/constants/storeMutations';

export default {
  name: 'Returns_AboveTheFold',
  created() {
    this.$store.commit(storeMutations.SET_MODAL_SUPPRESSION, true);
  },
  destroyed() {
    this.$store.commit(storeMutations.SET_MODAL_SUPPRESSION, false);
  },
};
